import { render } from "./CourseSection.vue?vue&type=template&id=9ad549be&scoped=true"
import script from "./CourseSection.vue?vue&type=script&lang=js"
export * from "./CourseSection.vue?vue&type=script&lang=js"

import "./CourseSection.vue?vue&type=style&index=0&id=9ad549be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ad549be"]])

export default __exports__